export default function blogGrid() {
  return {
    _id: false,
    type: 'droplet.blogGrid',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    placeholder: 'Search...',
    customList: false,
    paginate: 24,
    sortKey: false,
    sort: 'newest',
    filterText: 'Filters',
    match: 'all',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-grid/droplet.schema.js